class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector("a");
    if (!removeFilterNode) return;

    removeFilterNode.addEventListener("click", (e) => {
      e.preventDefault();
      const filtersForm =
        this.closest("collection-filters-form") || document.querySelector("collection-filters-form");
      if (!filtersForm?.renderPage) return;

      const params = new URL(removeFilterNode.href, window.location.origin).searchParams;

      const shopBySize = document.querySelector("shop-by-size");
      const sizeParamName = shopBySize?.dataset?.paramName;
      if (sizeParamName) {
        const hasSize = params.getAll(sizeParamName).length > 0;
        window.CalypsaShopBySize?.syncAvailabilityForSize(params, hasSize);
      }

      filtersForm.renderPage(params.toString());
    });
  }
}

customElements.define("facet-remove", FacetRemove);
